document.addEventListener('click', function (e) {
  var tabBtn = e.target.closest('.size-chart-tab');
  if (tabBtn) {
    var wrapper = tabBtn.closest('.size-chart-wrapper');
    var target = tabBtn.getAttribute('data-tab');
    wrapper.querySelectorAll('.size-chart-tab').forEach(function (t) {
      t.setAttribute('aria-selected', t === tabBtn ? 'true' : 'false');
    });
    wrapper.querySelectorAll('.size-chart-panel').forEach(function (p) {
      p.hidden = p.getAttribute('data-panel') !== target;
    });
    return;
  }

  var unitBtn = e.target.closest('.size-chart-unit-btn');
  if (unitBtn) {
    var wrapper2 = unitBtn.closest('.size-chart-wrapper');
    var unit = unitBtn.getAttribute('data-unit');
    wrapper2.setAttribute('data-unit', unit);
    wrapper2.querySelectorAll('.size-chart-unit-btn').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-unit') === unit ? 'true' : 'false');
    });
    return;
  }

  var addBtn = e.target.closest('.size-chart-add-to-bag');
  if (addBtn) {
    handleSizeChartAddToBag(addBtn);
  }
});

document.addEventListener('change', function (e) {
  if (e.target.name !== 'size-chart-size') return;
  var wrapper = e.target.closest('.size-chart-wrapper');
  wrapper.querySelectorAll('.size-chart-row[data-size]').forEach(function (row) {
    row.classList.toggle('is-selected', row.contains(e.target) && e.target.checked);
  });

  var addBtn = wrapper.querySelector('.size-chart-add-to-bag');
  if (addBtn) addBtn.disabled = false;

  var message = wrapper.querySelector('.size-chart-add-message');
  if (message) message.hidden = true;
});

function handleSizeChartAddToBag(addBtn) {
  var wrapper = addBtn.closest('.size-chart-wrapper');
  var panel = addBtn.closest('.size-chart-panel');
  var message = panel.querySelector('.size-chart-add-message');
  var selectedRow = wrapper.querySelector('.size-chart-row.is-selected[data-size]');

  function showMessage(text) {
    if (!message) return;
    message.textContent = text;
    message.hidden = false;
  }

  if (!selectedRow) {
    showMessage('Please select a size first.');
    return;
  }

  var size = selectedRow.getAttribute('data-size').trim().toLowerCase();
  var variantSelects = document.querySelector('variant-selects');
  var matchInput = null;

  if (variantSelects) {
    var inputs = Array.prototype.slice.call(variantSelects.querySelectorAll('input[type="radio"]'));
    matchInput = inputs.find(function (input) {
      var optionName = (input.getAttribute('data-option-name') || '').toLowerCase();
      return optionName.indexOf('size') !== -1 && input.value.trim().toLowerCase() === size;
    });
    if (!matchInput) {
      matchInput = inputs.find(function (input) {
        return input.value.trim().toLowerCase() === size;
      });
    }
  }

  function submit() {
    var submitBtn = document.querySelector('product-form button[type="submit"][name="add"]');
    if (!submitBtn) {
      showMessage('Could not find the add-to-cart button on this page.');
      return;
    }
    if (submitBtn.disabled) {
      showMessage('That size is currently sold out.');
      return;
    }
    if (message) message.hidden = true;
    submitBtn.click();
    var modal = wrapper.closest('modal-dialog');
    if (modal && typeof modal.hide === 'function') modal.hide();
  }

  if (matchInput && !matchInput.checked) {
    matchInput.checked = true;
    matchInput.dispatchEvent(new Event('change', { bubbles: true }));

    var settled = false;
    function settle() {
      if (settled) return;
      settled = true;
      submit();
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // Dawn recomputes availability via a network request before it enables/disables
      // the real add-to-cart button, so wait for its own "done updating" event instead
      // of guessing a fixed delay (a slow connection was reading the button's stale
      // disabled state and reporting in-stock sizes as sold out).
      var unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, function () {
        unsubscribe();
        settle();
      });
      setTimeout(function () {
        unsubscribe();
        settle();
      }, 2000);
    } else {
      setTimeout(settle, 400);
    }
  } else {
    submit();
  }
}
